/**
 * Produktsidan i apohem-stil (sections/main-product.liquid, assets/product-page.css).
 *
 * 1. "Läs mer": beskrivningen kortas till några rader; knappen visas bara när texten är längre.
 * 2. Recensioner: Judge.me-widgeten flyttas från app-sektionen in i dragspelet "Recensioner".
 *    Stjärnorna vid priset (länk till #judgeme_product_reviews) öppnar dragspelet och scrollar dit.
 * 3. Sticky-baren på mobil: antalet där speglas mot sidans antalväljare (det är den som skickas).
 */
(function () {
  /* ── 1. Läs mer ─────────────────────────────────────────────────────────── */
  function setupClamp(root) {
    var content = root.querySelector('[data-clamp-content]');
    var toggle = root.querySelector('[data-clamp-toggle]');
    if (!content || !toggle || root._clamp) return;
    root._clamp = true;

    var label = toggle.querySelector('[data-clamp-label]');

    function measure() {
      if (toggle.getAttribute('aria-expanded') === 'true') return;
      root.classList.add('is-clamped');
      var overflows = content.scrollHeight - content.clientHeight > 4;
      root.classList.toggle('is-clamped', overflows);
      toggle.hidden = !overflows;
    }

    toggle.addEventListener('click', function () {
      var expand = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', expand ? 'true' : 'false');
      root.classList.toggle('is-clamped', !expand);
      if (label) label.textContent = expand ? toggle.dataset.labelLess : toggle.dataset.labelMore;
    });

    measure();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);
    window.addEventListener('resize', measure);
  }

  /* ── 2. Recensioner i dragspel ──────────────────────────────────────────── */
  function setupReviews() {
    var accordion = document.querySelector('[data-reviews-accordion]');
    if (!accordion || accordion._reviews) return;

    var slot = accordion.querySelector('[data-reviews-slot]');
    var widget = document.getElementById('judgeme_product_reviews') || document.querySelector('.jdgm-review-widget');
    if (!slot || !widget || accordion.contains(widget)) return;
    accordion._reviews = true;

    var block = widget.closest('.shopify-app-block') || widget;
    var sourceSection = block.closest('.shopify-section');

    slot.appendChild(block);
    accordion.hidden = false;

    // App-sektionen står tom kvar: dölj den så att den inte lämnar ett glapp
    if (sourceSection && !sourceSection.contains(accordion) && !sourceSection.querySelector('.shopify-app-block, [id^="shopify-block"]')) {
      sourceSection.hidden = true;
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('a[href$="#judgeme_product_reviews"]');
      if (!link || link.pathname !== window.location.pathname) return;
      event.preventDefault();
      if (!accordion.open) accordion.open = true;
      accordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ── 3. Antal i sticky-baren ────────────────────────────────────────────── */
  function setupQuantityMirror(mirror) {
    if (mirror._mirror) return;
    var main = document.getElementById(mirror.getAttribute('data-quantity-mirror'));
    var mirrorInput = mirror.querySelector('input');
    if (!main || !mirrorInput) return;
    mirror._mirror = true;

    var mainSelector = main.closest('quantity-selector');

    function copy(from, to) {
      if (to.value === from.value) return;
      to.value = from.value;
      to.size = Math.max(String(from.value).length + 1, 2);
    }

    // Plus/minus sätter värdet utan att skicka någon händelse: läs av efter klicket
    mirror.addEventListener('click', function () { copy(mirrorInput, main); });
    mirrorInput.addEventListener('input', function () { copy(mirrorInput, main); });
    mirrorInput.addEventListener('change', function () { copy(mirrorInput, main); });

    if (mainSelector) mainSelector.addEventListener('click', function () { copy(main, mirrorInput); });
    main.addEventListener('input', function () { copy(main, mirrorInput); });
    main.addEventListener('change', function () { copy(main, mirrorInput); });

    copy(main, mirrorInput);
  }

  function init(root) {
    root = root || document;
    Array.prototype.forEach.call(root.querySelectorAll('[data-clamp]'), setupClamp);
    Array.prototype.forEach.call(root.querySelectorAll('[data-quantity-mirror]'), setupQuantityMirror);
    setupReviews();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Temaeditorn
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
